module.exports = __webpack_public_path__ + "img/公司介绍3.cbcc2d91.jpg";